module.exports = __webpack_public_path__ + "c63242e61bc26f58bb92d925f5fac64d.svg";